<!-- eslint-disable -->
<template>
  <div class='template_header'>
    <div class='branding_container'>
      <img
        @click.prevent="gotoHome"
        src="/dynamic/images/b1/small_logo_with_text.png"
        class="company_logo"
      >
      <span class="company_name">DGnet WebGUI</span>
    </div>
    <div class="header_buttons" v-if="!DV_isAuthenticated">
      <button 
        v-if="!DV_isInitialized && $route.path !== '/login'"
        :disabled="true" 
      >Loading...</button>
      <button v-else-if="$route.path === '/'" @click.prevent="gotoLoginPage">Login</button>
    </div>
    <div v-else-if="$route.path === '/'" class="header_buttons">
      <button @click.prevent="gotoDashboard">Control Panel</button>
    </div>
    <div class="dashboard_header" v-if="$route.path === '/login'">
      <div class="dashboard_title">
        <h1>Login</h1>
      </div>
    </div>
    <div class="dashboard_header" v-if="DV_isAuthenticated && $route.path === '/dashboard'">
      <div class="dashboard_title">
        <h1>Control Panel Home</h1>
      </div>
      <div class="user_badge">
        <div class="badge">
          <i class="fas fa-user"></i>
        </div>
        <div class="user_details">
          <span class="user_name">{{DV_username}}</span>
          <div class="sign_out"> 
            <button @click.stop="logout">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
    data() {
      return {
        DV_isGuest: false,
        DV_isAuthenticated: false,
        DV_isInitialized: false,
        DV_username: ''
      }
    },
    mounted() {
      const CI = this
      CI.waitWatchdogReady();
    },
    methods: {
      logout() {
        window.G_firebase_auth.bi5SignOut()
      },
      waitWatchdogReady() {
        const CI = this
        //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
        if (window.G_vue_instance && window.G_vue_instance.$data.webGui.watchdogDbConnected === true) {
          CI.DV_isInitialized = true;
          CI.DV_isGuest = window.G_vue_instance.$root.$data.userInfo.isGuest;
          CI.DV_isAuthenticated = window.G_vue_instance.$root.$data.userInfo.authenticated;
          if (CI.DV_isAuthenticated) {
            const user_info = window.G_web_gui_data.IV_user_info
            const f_name = user_info['first_name'] ? user_info['first_name'].trim() : ""
            const l_name = user_info['last_name'] ? user_info['last_name'].trim() : ""
            
            CI.DV_username = `${f_name} ${l_name}`            
            if (CI.DV_username.trim() === "") {CI.DV_username = "Watchdog User"}
          }
        } else {
          setTimeout(CI.waitWatchdogReady, 200);
        }
      },
      gotoHome() {
        location.assign(window.location.origin + '/');
      },
      gotoDashboard() {
        const CI = this;
        if (window.G_firebase_auth.IV_token_verified === true && 
            window.G_firebase_auth.IV_is_guest === false) 
        {
          window.G_vue_instance.$router.push('/dashboard');
          return;
        }

        if (CI.DV_isAuthenticated !== true || CI.DV_isGuest === true) {
          localStorage.clear();
          location.assign(window.location.origin + '/login');
          return;
        }
        
        if (CI.DV_isAuthenticated === true && CI.DV_isGuest === false) {
          window.G_vue_instance.$router.push('/dashboard');
        }
      },
      gotoLoginPage() {
        location.assign(window.location.origin + '/login');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/public/TemplateHeader.vue